import React, { Component } from "react";
import Header from "../Shared/Header";
import IconInput from "../Shared/IconInput";
import SuccessAlert from "../Shared/SuccessAlert";
import ForgotPasswordService from "./ForgotPassword.service";
import "./ForgotPassword.scss";
import mail from "../../assets/image/icon/mail black.png";
export default class ForgotPassword extends Component {
    state = {
        email: undefined,
        emailIsInvalid: false,
        success: false,
        isLoading: false
    };

    goToResetPassword = () => {
        this.props.history.push("/resetPassword?email=" + this.state.email);
    };

    forgotPassword = () => {
        if (
            !this.state.email ||
            this.state.emailIsInvalid
        ) {
            let newState = {};
            if (!this.state.email)
                newState.emailIsInvalid = "This field is required.";
            this.setState(newState);
            return;
        }

        let newState = {};
        
        // Check if introduced value is a valid email.

        const isEmailValid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!isEmailValid.test(this.state.email.toLowerCase())) {
            newState.emailIsInvalid = "Introduced email is not valid.";
        }

        if (Object.entries(newState).length !== 0) {
            this.setState(newState);
            return;
        }

        // Start loader.

        this.setState({
            isLoading: true
        });

        // Check if introduced email is registered.

        ForgotPasswordService.emailExists(this.state.email.toLowerCase())
            .then(response => {
                ForgotPasswordService.forgotPassword(
                    this.state.email
                )
                    .then(response => {
                        this.setState({
                            success: true
                        });
                    })
                    .catch(error => {
                        this.props.alert({
                            theme: "error",
                            message: error.message
                        });
                        this.setState({
                            isLoading: false
                        });
                    });
            })
            .catch(error => {
                this.setState({
                    emailIsInvalid: "Introduced email is not registered.",
                    isLoading: false
                });
                return;
            });
    };

    onKeyPress = e => {
        if (e.key === "Enter") {
            this.forgotPassword();
        }
    };

    onNewEmailValue = e => {
        if (this.state.emailIsInvalid)
            this.setState({
                emailIsInvalid: false
            });

        this.setState({
            email: e.target.value
        });
    };

    render() {
        return (
            <div>
                <Header />
                <div className="forgot d-flex justify-content-center align-items-center">
                    <div className="position-relative forgot-box d-flex flex-column justify-content-center align-items-center">
                        {this.state.success ? (
                            <SuccessAlert message="Email sent!">
                                <button
                                    className="btn btn-outline-light mt-3"
                                    onClick={this.goToResetPassword}
                                >
                                    Reset Password
                                </button>
                            </SuccessAlert>
                        ) : (
                            ""
                        )}
                        <div className="d-flex w-100 align-items-center mb-3">
                            <h1 className="ml-2">Forgot your password?</h1>
                        </div>
                        <div className="w-100 align-items-center mb-3">
                            <p className="ml-2">Please introduce the email associated with your account.</p>
                            <p className="ml-2">We'll send you a code so that you can reset your password.</p>
                        </div>
                        <IconInput
                            isInvalid={this.state.emailIsInvalid}
                            onValueChange={this.onNewEmailValue}
                            onKeyPress={this.onKeyPress}
                            icon={mail}
                            type="email"
                            placeholder="Email"
                        />
                        <button
                            type="button"
                            className="btn btn-primary mt-1 mb-2 w-100 btn-signup"
                            onClick={this.forgotPassword}
                            disabled={this.state.isLoading}
                        >
                            {this.state.isLoading ? (
                                <div
                                    id="btn-login-spinner"
                                    className="spinner-border spinner-border-sm text-light"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                "Submit"
                            )}
                        </button>
                        <a href="login">Cancel</a>
                    </div>
                </div>
            </div>
        );
    }
}
